import "../styles/AdminInterface.css"
/* import "../styles/App.css"
 */import React, { useState, useEffect, useMemo } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { TextField, FormControl, InputLabel, Button,Tooltip , Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import TimerIcon from '@mui/icons-material/Timer';

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'


// ─────────────────────────────────────────────────────────────
// Devis 2026-1 : meilleurs scores et temps de jeu PAR NIVEAU
// ─────────────────────────────────────────────────────────────
const NUMEROS_JEUX = {
  "Compta 1 - Attaque des cupcakes": 11,
  "Compta 2 - Quiz en folie": 12,
  "Compta 3 - Panique au PCG": 13,
  "Compta 4 - Balance ton écriture": 14,
  "Compta 5 - Belle brioche": 15,
  "Compta 6 - Chamallows": 16,
  "SI 1 - Datman": 21,
  "SI 2 - Casse-tête ERP": 22,
  "SI 3 - Train de processus": 23,
  "SI 4 - Datacrush": 24,
  "SI 5 - Quiz en folie": 25,
}
const NOMS_JEUX = Object.fromEntries(Object.entries(NUMEROS_JEUX).map(([nom, num]) => [num, nom]))

/** "Compta 4 - Balance ton écriture" → 14 ; "Tous" → null */
const jeuVersNum = (libelle) => NUMEROS_JEUX[libelle] ?? null

/** 3725 → "1 h 02 min 05 s" */
const formatDuree = (secondes) => {
  const t = Math.max(0, Math.round(Number(secondes) || 0))
  const h = Math.floor(t / 3600)
  const m = Math.floor((t % 3600) / 60)
  const sec = t % 60
  const p2 = (n) => String(n).padStart(2, "0")
  if (h > 0) return `${h} h ${p2(m)} min ${p2(sec)} s`
  if (m > 0) return `${m} min ${p2(sec)} s`
  return `${sec} s`
}

/** "2026-09-26 18:05:00" → "26/09/2026 18:05" */
const formatDate = (d) => {
  if (!d || typeof d !== "string") return ""
  const [jour, heure] = d.split(" ")
  const [a, m, j] = jour.split("-")
  return `${j}/${m}/${a}` + (heure ? " " + heure.slice(0, 5) : "")
}

/** Cellule CSV sûre pour Excel (séparateur ;) */
const celluleCSV = (v) => {
  const t = v === null || v === undefined ? "" : String(v)
  return /[;"\n\r]/.test(t) ? `"${t.replace(/"/g, '""')}"` : t
}

/**
 * Nom de fichier sans accents ni caractères interdits : avec « Classement
 * général.csv », Chrome enregistrait le fichier sous le nom « download ».
 */
const nomFichierSur = (nom) => String(nom)
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .replace(/[\\/:*?"<>|]+/g, "-")
  .replace(/\s+/g, " ")
  .trim()

const telechargerCSV = (nomFichier, entetes, lignes) => {
  const contenu = [
    entetes.map(celluleCSV).join(";"),
    ...lignes.map(l => l.map(celluleCSV).join(";"))
  ].join("\n")
  const blob = new Blob(["\uFEFF" + contenu], { type: "text/csv;charset=utf-8;" })
  const lien = document.createElement("a")
  const url = URL.createObjectURL(blob)
  lien.setAttribute("href", url)
  lien.setAttribute("download", nomFichierSur(nomFichier))
  document.body.appendChild(lien)
  lien.click()
  document.body.removeChild(lien)
  // Différé : certains Safari annulent le téléchargement si l'URL est libérée tout de suite.
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

const AdminScores = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.username !== undefined && !user.username.toUpperCase().includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)

  const [popupText, setPopupText] = useState(null)

  const [users, setUsers] = useState(null)
  const [localUsers, setLocalUsers] = useState(users);
  const [popupUser, setPopupUser] = useState(null)
  const [newUser, setNewUser] = useState(null)
  const [userList,setUserList] = useState([])
  const [localUserList, setLocalUserList] = useState([])

  const liste_jeux = ["Tous","Compta 1 - Attaque des cupcakes", "Compta 2 - Quiz en folie", "Compta 3 - Panique au PCG","Compta 4 - Balance ton écriture","Compta 5 - Belle brioche",
    "Compta 6 - Chamallows","SI 1 - Datman","SI 2 - Casse-tête ERP","SI 3 - Train de processus","SI 4 - Datacrush","SI 5 - Quiz en folie"]
  
  // const [annee, setAnnee] = useState("2025-2026")
  const now = new Date();
  const debutAnnee = (now.getMonth() > 7 || (now.getMonth() === 7 && now.getDate() >= 25))
    ? now.getFullYear()
    : now.getFullYear() - 1;

  const [annee, setAnnee] = useState(`${debutAnnee}-${debutAnnee + 1}`)

  const [numJeu, setNumJeu] = useState("Tous")
  const [nom, setNom] = useState('Tous');
  const [prenom, setPrenom] = useState('Tous');
  const [pseudo, setPseudo] = useState('Tous');
  const [campus, setCampus] = useState('Tous');
  const [programme, setProgramme] = useState('Tous');
  const [groupe, setGroupe] = useState('Tous');
  const [groupes,setGroupes]=useState([])

  // Données exemple pour les options des filtres
  const [anneesOptions,setAnneesOptions] = useState(["2023-2024","2024-2025","2025-2026","2026-2027","2027-2028"])

  const [nomOptions,setNomOptions] = useState([])
  const [prenomOptions,setPrenomOptions] = useState([])
  const [jeuxOptions,setJeuxOptions] = useState([])
  const [pseudosOptions,setPseudosOptions] = useState([])
  const [campusOptions,setCampusOptions] = useState([])
  const [programmeOptions,setProgrammeOptions] = useState([])
  const [groupesOptions,setGroupesOptions] = useState([])

  const handleFilterChange = (setter) => (event) => {
    setter(event.target.value);
  };

  useEffect(() => {
    const getClassement = async () => {
      try {
        const response = await BackendAPI.getClassements()

        // Handle the response
        if (response.connectionApprouvee) {
          // console.log("Connexion approuvée");
          // console.log(response.classement)
          setUserList(response.classement);
        } else {
          console.error("Connection not approved:", response);
        }

      } catch (error) {
        console.error("Error fetching classement:", error);
      }
    };

    getClassement();
  }, []);


  // Devis 2026-1 : détail par niveau, rechargé à chaque changement d'année
  // scolaire (filtrage fait côté serveur sur la date réelle de chaque partie).
  const [scoresNiveaux, setScoresNiveaux] = useState([])

  useEffect(() => {
    const charger = async () => {
      let dateDebut = null
      let dateFin = null
      if (annee && annee !== "Tous") {
        const debut = parseInt(annee.split("-")[0], 10)
        dateDebut = `${debut}-08-25`       // mêmes bornes que isDateInRange
        dateFin = `${debut + 1}-08-24`
      }
      setScoresNiveaux(await BackendAPI.getScoresNiveaux(dateDebut, dateFin))
    }
    charger()
  }, [annee])

  /** idUser → lignes (jeu, niveau) */
  const niveauxParEtudiant = useMemo(() => {
    const index = {}
    scoresNiveaux.forEach((l) => {
      if (!index[l.idUser]) index[l.idUser] = []
      index[l.idUser].push(l)
    })
    Object.values(index).forEach((lignes) => lignes.sort((a, b) => a.numJeu - b.numJeu || a.niveau - b.niveau))
    return index
  }, [scoresNiveaux])

  const [hoveredRow, setHoveredRow] = useState(null);

  const handleMouseEnter = (u) => {
    setHoveredRow(u);
  };

  const handleMouseLeave = () => {
    setHoveredRow(null);
  };


const getUniqueValues = (data, attribute,campus, programme, groupe) => {

    if(data==null ) return []

    const filtered_data = data
        .filter((val)=>val.campus==campus || campus == "Tous" || attribute=="campus")
        .filter((val)=>val.programme==programme || programme == "Tous" || attribute=="campus" || attribute=="programme")
        .filter((val)=>val.groupe==groupe || groupe == "Tous" || attribute=="campus"  || attribute=="programme" || attribute=="groupe")

    const values = filtered_data?.map(item => {
      if (attribute === "numJeu") {
        return item[attribute] - 10; // Si l'attribut est 'numJeu', soustraire 10
      }
      return item[attribute]; // Sinon, retourner la valeur normale de l'attribut
    });
  
    const uniqueValues = [...new Set(values)].filter((val)=>val!="").sort(); 
    uniqueValues.unshift("Tous"); 
    return uniqueValues;
  };


  useEffect(() => {
    if (userList !== null && userList.length>0) {
      setNomOptions(getUniqueValues(userList,"nom",campus,programme,groupe))
      setPrenomOptions(getUniqueValues(userList,"prenom",campus,programme,groupe))
      setJeuxOptions(liste_jeux)
      setPseudosOptions(getUniqueValues(userList,"pseudo",campus,programme,groupe))
      // setCampusOptions(getUniqueValues(userList,"campus"))
      // setProgrammeOptions(getUniqueValues(userList,"programme"))
      // setGroupesOptions(getUniqueValues(userList,"groupe"))
      filterAndGroupList(userList)
    }
  }, [userList])

  // useEffect(()=>{
  //   // console.log(groupes)
  //   if (groupes !== null && groupes.length>0) {
  //     setCampusOptions(getUniqueValues(groupes,"campus",campus, programme, groupe))
  //     setProgrammeOptions(getUniqueValues(groupes,"programme",campus, programme, groupe))
  //     setGroupesOptions(getUniqueValues(groupes,"groupe",campus, programme, groupe))
  //   }
  // },[groupes])

    // useEffect(()=>{
    //   setProgramme("Tous")
  
    // },[campus])
    // useEffect(()=>{
    //   setGroupe("Tous")
    // },[programme])

useEffect(() => {
  const collectGroups = async () => {
    return await BackendAPI.getGroupes();
  };

  const load = async () => {
    if (!groupes || groupes.length === 0) {
      const grps = await collectGroups();  // <- ici on attend la Promise
      // console.log(grps);
      setGroupes(grps);
    }
  };

  load();
}, [userList]);


  useEffect(()=>{
    if (groupes !== null && groupes.length>0) {
      setCampusOptions(getUniqueValues(groupes,"campus",campus, programme, groupe))
      setProgrammeOptions(getUniqueValues(groupes,"programme",campus, programme, groupe))
      setGroupesOptions(getUniqueValues(groupes,"groupe",campus, programme, groupe))
    }
    
  },[groupes,campus,programme])

  useEffect(()=>{
    if( groupes.filter((val)=> val.programme== programme && val.campus==campus).length==0){
      setProgramme("Tous")
    }

      if( groupes.filter((val)=> val.programme== programme && val.campus==campus && val.groupe == groupe).length==0){
      setGroupe("Tous")
    }
    
  },[campus])

  useEffect(()=>{   
    if( groupes.filter((val)=>val.groupe== groupe && val.programme== programme && val.campus == campus).length==0){
      setGroupe("Tous")
    }
  },[programme])

  useEffect(()=>{
    if(groupe!="Tous"){
      setProgramme(groupes.filter((val)=>val.groupe== groupe)[0].programme)
      setCampus(groupes.filter((val)=>val.groupe== groupe)[0].campus)
    }
  },[groupe])

    

  const filterAndGroupList=(userList)=>{

    var jeu = "Tous"
    switch (numJeu) {
      case "Compta 1 - Attaque des cupcakes":
        jeu="11"
        break;
      case "Compta 2 - Quiz en folie":
        jeu="12"
        break;
      case "Compta 3 - Panique au PCG":
        jeu="13"
        break;
      case "Compta 4 - Balance ton écriture":
        jeu="14"
        break;
      case "Compta 5 - Belle brioche":
        jeu="15"
        break;
      case "Compta 6 - Chamallows":
        jeu="16"
        break;
      case "SI 1 - Datman":
        jeu="21"
        break;
      case "SI 2 - Casse-tête ERP":
        jeu="22"
        break;
      case "SI 3 - Train de processus":
        jeu="23"
        break;
      case "SI 4 - Datacrush":
        jeu="24"
        break;
      case "SI 5 - Quiz en folie":
        jeu="25"
        break;

      default:
        break;
    }
    
function isDateInRange(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return false;

  const p = dateStr.split("-");
  if (p.length < 2) return false;
  const inputDate = new Date(+p[0], (+p[1]) - 1, p[2] ? +p[2] : 1);
  if (isNaN(inputDate)) return false;

  const year = parseInt(annee.split("-")[0], 10);
  const startDate = new Date(year, 7, 25);       // 25 août
  const endDate   = new Date(year + 1, 7, 24);   // 24 août

  return inputDate >= startDate && inputDate <= endDate;
}

    const groupedByUser = userList
      .filter((user) => (jeu && jeu!="Tous" ? user.numJeu==jeu : true))
      .filter((user) => (annee && annee!="Tous" ? isDateInRange(user.dateUpdate): true))
      .filter((user) => (nom && nom!="Tous" ? user.nom==nom: true))
      .filter((user) => (prenom && prenom!="Tous" ? user.prenom==prenom: true))
      .filter((user) => (pseudo && pseudo!="Tous" ? user.pseudo==pseudo: true))
      .filter((user) => (campus && campus!="Tous" ? user.campus==campus: true))
      .filter((user) => (programme && programme!="Tous" ? user.programme==programme: true))
      .filter((user) => (groupe && groupe!="Tous" ? user.groupe==groupe: true))
      /*.filter((user) => (etudiant ? user.etudiant.includes(etudiant) : true))
      .filter((user) => (pseudo ? user.pseudo.includes(pseudo) : true))
      .filter((user) => (campus ? user.campus.includes(campus) : true))
      .filter((user) => (groupe ? user.groupe.includes(groupe) : true)) */
      .reduce((acc, curr) => {
      const { idUser, bestScore } = curr;
  
      // Vérifier si l'utilisateur existe déjà dans l'accumulateur
      if (!acc[idUser]) {
          acc[idUser] = { ...curr, totalBestScore: bestScore };
      } else {
          acc[idUser].totalBestScore += bestScore;
      }
  
      return acc;
    }, {});
  
    // Convertir l'objet en tableau
    // console.log(Object.values(groupedByUser).sort((val1,val2)=>val2.totalBestScore - val1.totalBestScore))
    setLocalUserList( Object.values(groupedByUser));
    return Object.values(groupedByUser)
  }

  useEffect(()=>{
    
    const localUserList=filterAndGroupList(userList)
    setJeuxOptions(liste_jeux)
   
if (nom=="Tous"){
      

      if(groupe=="Tous"){
        
        if(campus=="Tous"){
          
          
          if(pseudo=="Tous"){
            setPrenomOptions(getUniqueValues(userList,"prenom",campus,programme,groupe))
            setNomOptions(getUniqueValues(userList,"nom",campus,programme,groupe))
            setPseudosOptions(getUniqueValues(userList,"pseudo",campus,programme,groupe))
            // setCampusOptions(getUniqueValues(userList,"campus"))
            // setProgrammeOptions(getUniqueValues(userList,"programme"))
            // setGroupesOptions(getUniqueValues(userList,"groupe"))
          }else{
            setPrenomOptions(getUniqueValues(localUserList,"prenom",campus,programme,groupe))
            setNomOptions(getUniqueValues(localUserList,"nom",campus,programme,groupe))
            setPseudosOptions(getUniqueValues(localUserList,"pseudo",campus,programme,groupe))
            // setCampusOptions(getUniqueValues(localUserList,"campus"))
            // setProgrammeOptions(getUniqueValues(userList,"programme"))
            // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
          }

        }else{
          setPrenomOptions(getUniqueValues(localUserList,"prenom",campus,programme,groupe))
          setNomOptions(getUniqueValues(localUserList,"nom",campus,programme,groupe))
          setPseudosOptions(getUniqueValues(localUserList,"pseudo",campus,programme,groupe))
          // setCampusOptions(getUniqueValues(localUserList,"campus"))
          // setProgrammeOptions(getUniqueValues(userList,"programme"))
          // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
        }


      }else{
        setPrenomOptions(getUniqueValues(localUserList,"prenom",campus,programme,groupe))
        setNomOptions(getUniqueValues(localUserList,"nom",campus,programme,groupe))
        setPseudosOptions(getUniqueValues(localUserList,"pseudo",campus,programme,groupe))
        // setCampusOptions(getUniqueValues(localUserList,"campus"))
        // setProgrammeOptions(getUniqueValues(userList,"programme"))
        // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
      }




    }else{
      setPrenomOptions(getUniqueValues(localUserList,"prenom",campus,programme,groupe))
      setNomOptions(getUniqueValues(localUserList,"nom",campus,programme,groupe))
      setPseudosOptions(getUniqueValues(localUserList,"pseudo",campus,programme,groupe))
      // setCampusOptions(getUniqueValues(localUserList,"campus"))
      // setProgrammeOptions(getUniqueValues(userList,"programme"))
      // setGroupesOptions(getUniqueValues(localUserList,"groupe"))
    }
    

  },[annee,numJeu,nom,prenom,pseudo,campus,programme,groupe])



  const extractScores = (u) => {
    const data = userList.filter((val) => val.idUser === u.idUser); // Corrigez l'opérateur d'affectation `=` par `===`
    const gameScores = {};
  
    // Parcours de chaque entrée dans les données
    data.forEach(entry => {
      // Vérifie si le score est valide et supérieur à 0
      if (entry.bestScore > 0) {
        // Enregistre le score associé au numéro de jeu
        gameScores[`Jeu ${entry.numJeu-10}`] = entry.bestScore; 
      }
    });
  
    // Transforme les résultats en tableau formaté avec des balises HTML pour les sauts de ligne
    return Object.entries(gameScores)
    .sort(([gameA], [gameB]) => {
      // Extrait le numéro du jeu pour effectuer un tri numérique
      const numA = parseInt(gameA.replace('Jeu ', ''), 10);
      const numB = parseInt(gameB.replace('Jeu ', ''), 10);
      return numA - numB;
    })
    .map(([game, score]) => `${game} : ${score} pts`)
    .join('<br>'); // Utilisation de <br> pour le rendu HTML
  };

  // Devis 2026-1 : au survol, meilleurs scores de CHAQUE NIVEAU du jeu
  // sélectionné (ou de tous les jeux si « Tous »), avec le temps de jeu.
  const renderDetailNiveaux = (u) => {
    const jeu = jeuVersNum(numJeu)
    const lignes = (niveauxParEtudiant[u.idUser] || []).filter((l) => jeu === null || l.numJeu === jeu)

    if (lignes.length === 0) {
      return (
        <span>
          {jeu === null
            ? <span dangerouslySetInnerHTML={{ __html: extractScores(u) }} />
            : <b>{numJeu}</b>}
          <br />
          <i>Pas encore de détail par niveau sur cette période.</i>
        </span>
      )
    }

    const parJeu = {}
    lignes.forEach((l) => { (parJeu[l.numJeu] = parJeu[l.numJeu] || []).push(l) })

    return (
      <span style={{ fontSize: 13, lineHeight: 1.5 }}>
        {Object.keys(parJeu).map((num) => (
          <span key={num}>
            <b>{NOMS_JEUX[num] || `Jeu ${num}`}</b><br />
            {parJeu[num].map((l) => (
              <span key={l.niveau}>
                Niveau {l.niveau} : <b>{l.bestScore} pts</b>
                {" "}({l.nbParties} partie{l.nbParties > 1 ? "s" : ""} · {formatDuree(l.tempsTotal)})
                <br />
              </span>
            ))}
          </span>
        ))}
      </span>
    )
  };
  
/*   const renderHoverToolTips=(u)=>{
    console.log(userList)
    return(
      `Détail scores info: ${u.totalBestScore}`
    )
  }
 */
const renderClassements = () => {
  if (userList !== null && userList.length > 0) {
    return (
      <TableContainer component={Paper} style={{ maxHeight: "100%" }} >
        <Table stickyHeader aria-label="customized table">
          <TableHead>
            <TableRow key={"HEAD"}>
              <TableCell align="center" style={{ width: 80 }}>Rang</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Nom</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Prénom</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Pseudo</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Campus</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Programme</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Groupe</TableCell>
              <TableCell align="center" style={{ width: 150 }}>Score</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {localUserList
              .sort((a, b) => b.totalBestScore - a.totalBestScore) // tri décroissant par score
              .map((u, index) => (
                <TableRow key={u.id} style={{ height: 40 }}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{u.nom}</TableCell>
                  <TableCell align="center">{u.prenom}</TableCell>
                  <TableCell align="center">{u.pseudo}</TableCell>
                  <TableCell align="center">{u.campus}</TableCell>
                  <TableCell align="center">{u.programme}</TableCell>
                  <TableCell align="center">{u.groupe}</TableCell>
                  <TableCell align="center" style={{ cursor: "pointer" }}>
                    <Tooltip
                      title={
                        hoveredRow && hoveredRow.id === u.id ? renderDetailNiveaux(u) : ''
                      }
                      placement="right"
                      arrow
                    >
                      <span
                        onMouseEnter={() => handleMouseEnter(u)}
                        onMouseLeave={handleMouseLeave}
                      >
                        {u.totalBestScore}
                      </span>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
};


const exportToCSV = () => {
  if (!localUserList || localUserList.length === 0) {
    alert("Aucun utilisateur à exporter !");
    return;
  }

  // Même format que l'export par niveau : cellules échappées (un « ; » ou un
  // guillemet dans un nom décalait les colonnes), colonne Programme ajoutée,
  // nom de fichier sans accents. Copie triée : la liste affichée n'est plus
  // réordonnée par l'export.
  const headers = ["Date", "Rang", "Nom", "Prénom", "Pseudo", "Email", "Campus", "Programme", "Groupe", "Score"];
  const rows = [...localUserList]
    .sort((a, b) => b.totalBestScore - a.totalBestScore)
    .map((u, index) => [
      u.dateUpdate,
      index + 1,
      u.nom,
      u.prenom,
      u.pseudo,
      u.email,
      u.campus,
      u.programme,
      u.groupe,
      u.totalBestScore
    ]);

  telechargerCSV(numJeu == "Tous" ? "Classement general.csv" : "Classement " + numJeu + ".csv", headers, rows);
};


// Devis 2026-1 : export détaillé — une ligne par étudiant / jeu / niveau,
// avec meilleur score et temps de jeu. Mêmes filtres que le tableau.
const exportDetailNiveauxCSV = () => {
  const jeu = jeuVersNum(numJeu)
  const lignes = scoresNiveaux
    .filter((l) => jeu === null || l.numJeu === jeu)
    .filter((l) => nom === "Tous" || l.nom === nom)
    .filter((l) => prenom === "Tous" || l.prenom === prenom)
    .filter((l) => pseudo === "Tous" || l.pseudo === pseudo)
    .filter((l) => campus === "Tous" || l.campus === campus)
    .filter((l) => programme === "Tous" || l.programme === programme)
    .filter((l) => groupe === "Tous" || l.groupe === groupe)
    .sort((a, b) =>
      String(a.nom).localeCompare(String(b.nom)) ||
      String(a.prenom).localeCompare(String(b.prenom)) ||
      a.numJeu - b.numJeu || a.niveau - b.niveau)

  if (lignes.length === 0) {
    alert("Aucune partie enregistrée par niveau pour ces filtres.")
    return
  }

  const entetes = [
    "Année scolaire", "Nom", "Prénom", "Pseudo", "Email", "Campus", "Programme", "Groupe",
    "Jeu", "Niveau", "Meilleur score",
    "Durée de la partie record", "Durée de la partie record (s)", "Date du meilleur score",
    "Nombre de parties",
    "Temps de jeu total", "Temps de jeu total (s)",
    "Temps moyen par partie", "Temps moyen par partie (s)",
    "Première partie", "Dernière partie",
  ]

  const rows = lignes.map((l) => [
    annee, l.nom, l.prenom, l.pseudo, l.email, l.campus, l.programme, l.groupe,
    NOMS_JEUX[l.numJeu] || l.numJeu, l.niveau, l.bestScore,
    formatDuree(l.dureeMeilleurePartie), l.dureeMeilleurePartie, formatDate(l.dateMeilleurScore),
    l.nbParties,
    formatDuree(l.tempsTotal), l.tempsTotal,
    formatDuree(l.tempsMoyen), l.tempsMoyen,
    formatDate(l.premierePartie), formatDate(l.dernierePartie),
  ])

  telechargerCSV(
    (jeu === null ? "Scores et temps par niveau - tous les jeux" : "Scores et temps par niveau - " + numJeu) + " - " + annee + ".csv",
    entetes,
    rows
  )
};


  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div
        className="body-admin"
      >
        <Typography variant="h1" color="primary">Scores</Typography>
        <Divider />
        {/* {
        popupText!=null ?
        <Popup open={true} text={popupText} reponse={"Supprimer Utilisateur"} handleClose={handleClosePopup} ></Popup>
        :
        null
      } */}
        <div style={{ margin: 10 }}  >
          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
            <FormControl size="small" variant="outlined">
              <InputLabel>Année</InputLabel>
              <Select
                value={annee}
                variant="outlined"
                onChange={handleFilterChange(setAnnee) }
              >
                {anneesOptions.map(c => (
                  <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Liste déroulante pour le Jeu */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Jeu</InputLabel>
              <Select
                value={numJeu}
                variant="outlined"
                onChange={handleFilterChange(setNumJeu) }
              >
                {jeuxOptions.map(c => (
                  <MenuItem key={c} value={c} style={{ paddingTop: 8, paddingBottom: 8 }}>{c}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
            <InputLabel>Nom</InputLabel>
              <Select
                value={nom}
                onChange={handleFilterChange(setNom)}
                label="Nom"
              >
                      {nomOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
              <InputLabel>Prénom</InputLabel>
              <Select
                value={prenom}
                onChange={handleFilterChange(setPrenom)}
                label="Prénom"
              >
                      {prenomOptions?.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Pseudo */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Pseudo</InputLabel>
              <Select
                value={pseudo}
                onChange={handleFilterChange(setPseudo)}
                label="Pseudo"
              >

                {pseudosOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Campus */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Campus</InputLabel>
              <Select
                value={campus}
                onChange={handleFilterChange(setCampus)}
                label="Campus"
              >

                {campusOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" variant="outlined">
              <InputLabel>Programme</InputLabel>
              <Select
                value={programme}
                onChange={handleFilterChange(setProgramme)}
                label="Programme"
              >

                {programmeOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Groupe */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Groupe</InputLabel>
              <Select
                value={groupe}
                onChange={handleFilterChange(setGroupe)}
                label="Groupe"
              >

                {groupesOptions.map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Tooltip title="Exporter le classement (CSV)" arrow>
              <IconButton aria-label="download" style={{padding:10}} onClick={exportToCSV}>
                <DownloadIcon  />
              </IconButton>
            </Tooltip>
            <Tooltip title="Exporter les meilleurs scores et temps de jeu par niveau (CSV)" arrow>
              <IconButton aria-label="export par niveau" style={{padding:10}} onClick={exportDetailNiveauxCSV}>
                <TimerIcon color="primary" />
              </IconButton>
            </Tooltip>
          </div>
          <br></br>
          {renderClassements()}

          {/*   <br></br>
          <Typography variant="h5" color="primary">Créer un nouvel étudiant</Typography>

          {renderNewUser()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>



        {/* </div> */}

      </div></div>
  );
}

export default AdminScores;

